import { EventEmitter } from 'events';
import { logout } from '@/services';

export const NeedLogin = 'need-login';
export const LoginSuccess = 'login-success';
export const Logout = 'logout';
export const LogoutSuccess = 'logout-success';
export const BackToHome = 'back-to-home';
export const AlreadyLogin = 'already-login';

/**
 * 登录事件
 */
const LoginEvent = new EventEmitter();
export default LoginEvent;

const logoutEventHandler = () => {
  logout().subscribe(() => {
    LoginEvent.emit(LogoutSuccess);
  });
};
LoginEvent.on(Logout, logoutEventHandler);
